export const isTouch = {
  data () {
    return {
      isTouch: !!('ontouchstart' in window || (navigator.msMaxTouchPoints > 0) || navigator.maxTouchPoints)
    }
  }
}
